module.exports = __WEBPACK_EXTERNAL_MODULE_26__;


//////////////////
// WEBPACK FOOTER
// external {"root":"moment","commonjs2":"moment","commonjs":"moment","amd":"moment"}
// module id = 26
// module chunks = 0 1